let routes = [
    {
        path: '/guide/home',
        meta: {
            title: '21秒体验指南',
            company: true
        },
        redirect: '/guide/home/0'
    },
    {
        path: '/guide/home/:step/:company?',
        name: 'guideHome',
        meta: {
            title: '21秒体验指南',
            company: true
        },
        component: () => import('../views/guide/home.vue')
    },
    {
        path: '/guide/menu/:company/:code?',
        name: 'guideMenu',
        meta: {
            title: '21秒体验指南',
            company: true
        },
        component: () => import('../views/guide/menu.vue')
    }
];

export default routes;
